import { InternalOrganization, InternalUser, OrganizationPackage } from '../../../organizations/types/Organizations'
import { PackageTier, PackageType } from '../../../plans/types/Plans'

/** Users that belong to an organization; `users/list/all` also lists the orphans with `organization: ''`. */
export const getUsersWithOrganization = (users: InternalUser[]) => users.filter((user) => !!user.organization)

/** Legacy's "Search Users with Email": a case-insensitive part of the e-mail. */
export const filterUsersByEmail = (users: InternalUser[], search: string) => {
  const term = search.trim().toLowerCase()
  return term ? users.filter((user) => user.email.toLowerCase().includes(term)) : users
}

/** The organization's first Insights package, as legacy's move dialog picks it. */
export const getMainPackage = (organization: Pick<InternalOrganization, 'packages'>): OrganizationPackage | undefined =>
  organization.packages.find(({ type }) => type === PackageType.Insights)

/** Legacy's "{name} / {main package}" label, `-` without a main package. */
export const getMoveTargetLabel = (organization: Pick<InternalOrganization, 'name' | 'packages'>) =>
  `${organization.name} / ${getMainPackage(organization)?.name ?? '-'}`

/** Without a main package the tier is unknown, so legacy keeps the organization in the subscription filter. */
export const hasSubscription = (organization: Pick<InternalOrganization, 'packages'>) => getMainPackage(organization)?.tier !== PackageTier.Free

/** Legacy's targets: named organizations other than the user's own, optionally only those with a subscription. */
export const getMoveTargets = (organizations: InternalOrganization[], currentOrganizationId: string | null, onlySubscriptions: boolean) =>
  organizations
    .filter((organization) => !!organization.name && organization.id !== currentOrganizationId)
    .filter((organization) => !onlySubscriptions || hasSubscription(organization))
    .sort((a, b) => a.name.localeCompare(b.name))

/** The organization column's text: the name, or the id of an unnamed organization. */
export const getOrganizationLabel = (organization: Pick<InternalOrganization, 'id' | 'name'>) => organization.name || organization.id
